import api from './api';

/**
 * Service para operações relacionadas ao usuário
 */
const usersService = {
  /**
   * Atualiza o tema do usuário autenticado
   * @param {number} theme - Valor do enum ThemeType (1-11)
   * @returns {Promise} Resposta da API
   */
  async updateTheme(theme) {
    const response = await api.put('/users/theme', { theme });
    return response.data;
  },

  /**
   * Obtém o tema atual do usuário autenticado
   * @returns {Promise<{theme: number|null, themeId: string|null}>}
   */
  async getTheme() {
    const response = await api.get('/users/theme');
    return response.data;
  },

  /**
   * Obtém preferências de notificação do usuário
   * @returns {Promise<{emailNotificationsEnabled: boolean}>}
   */
  async getNotificationPreferences() {
    const response = await api.get('/users/notifications/preferences');
    return response.data;
  },

  /**
   * Atualiza preferências de notificação do usuário
   * @param {boolean} emailNotificationsEnabled - Habilitar/desabilitar emails
   * @returns {Promise}
   */
  async updateNotificationPreferences(emailNotificationsEnabled) {
    const response = await api.put('/users/notifications/preferences', { emailNotificationsEnabled });
    return response.data;
  },

  /**
   * Busca um usuário pelo email
   * @param {string} email - Email do usuário a buscar
   * @returns {Promise<{id: string, name: string, email: string}>}
   */
  async lookupByEmail(email) {
    const response = await api.get('/users/lookup', { params: { email } });
    return response.data;
  },
};

export default usersService;
